import {
  mockProviders,
  mockReports,
  mockSites,
  mockTariffs,
  mockSubmissions,
  mockPayors,
  mockRemittances,
} from 'test-fixtures/mocks/frontend';

export const useTutorialReportManagementData = () => {
  return {
    reports: mockReports,
    sites: mockSites,
    providers: mockProviders,
    tariffs: mockTariffs,
    remittances: mockRemittances,
    submissions: mockSubmissions,
    payors: mockPayors,
    isLoading: false,
    isError: false,
    isFetching: false,
    errorMessage: '',
    refetchReports: () => {},
  };
};
